import React, { useEffect, useMemo, useState } from 'react'

import { useTranslation } from '../../contexts/I18nContext'
import { KEY_VALUES } from '../../constants'
import { THEME } from '../../styles'

import Styled from './BlockedContentPage.styled'

const BlockedContentPage = ({ className, blockedType, children }) => {
  const [type, setType] = useState('')
  useEffect(() => {
    setType(blockedType)
  }, [blockedType])

  const { t } = useTranslation()
  const content = useMemo(() => {
    switch (type) {
      case 'user':
        return {
          icon: 'error-stroke-32',
          title: t('REPORT.BLOCKED_PAGE.USER'),
        }
      case 'recipe':
        return {
          icon: 'eye-close-32',
          title: t('REPORT.BLOCKED_PAGE.RECIPE'),
        }
      default:
        return undefined
    }
  }, [type, t])

  return content ? (
    <Styled className={className}>
      <Styled.content>
        <Styled.icon
          name={content.icon}
          fill={THEME.COLORS.background.tertiary}
          width={240}
          height={240}
        />
        <Styled.title>{content.title}</Styled.title>
        <Styled.button
          role="button"
          tabIndex={0}
          onClick={() => setType('')}
          onKeyPress={(event) => {
            if (event.key === KEY_VALUES.ENTER) {
              setType('')
            }
          }}
        >
          <Styled.buttonIcon
            fill={THEME.COLORS.foreground.primary}
            name="eye-open-16"
            width={16}
            height={16}
          />
          <Styled.buttonLabel>
            {t('REPORT.BLOCKED_PAGE.DISPLAY_ANYWAY')}
          </Styled.buttonLabel>
        </Styled.button>

        <Styled.settingsLink to="/profile/display-settings/blocked-and-hidden-content">
          <Styled.settingsLinkLabel>
            {t('REPORT.BLOCKED_PAGE.GO_TO_SETTINGS')}
          </Styled.settingsLinkLabel>
          <Styled.settingsLinkIcon
            fill={THEME.COLORS.foreground.secondary}
            name="direction-right-16"
            width={16}
            height={16}
          />
        </Styled.settingsLink>
      </Styled.content>
    </Styled>
  ) : (
    children
  )
}

BlockedContentPage.defaultProps = {
  blockedType: '',
}

export default BlockedContentPage
